/**
 * Interrupteurs de fonctions renvoyés par l'API (GET /api/features, et inclus
 * dans /api/me/full). Pendant la cohabitation avec Jarvis V1, la V2 démarre en
 * lecture seule : on masque les actions fermées plutôt que de laisser
 * l'utilisateur tomber sur un refus. L'API refuse de toute façon (403
 * FEATURE_DISABLED) : ce masquage n'est qu'un confort.
 *
 * Par défaut (champ absent, API ancienne ou erreur) : FERMÉ.
 */
export type FeatureName =
  | 'ticket_state'
  | 'ticket_state_client'
  | 'ticket_assign'
  | 'ticket_edit'
  | 'ticket_edit_client'
  | 'time_entry'
  | 'messages'
  | 'attach_upload'
  | 'attach_delete'
  | 'ticket_create_staff'
  | 'ticket_create_client'
  | 'admin_accounts'
  | 'client_traitants'
  | 'password_change'
  | 'paybox'
  | 'cron_monthly'
  | 'read_tracking';

export interface FeatureState {
  read_only: boolean;
  features: Partial<Record<FeatureName, boolean>>;
}

export function featureEnabled(src: Partial<FeatureState> | null | undefined, name: FeatureName): boolean {
  return src?.features?.[name] === true;
}

/**
 * Création de point : interrupteur différent pour le staff (agent Digital
 * Team, `is_dt_agent`) et pour les clients, comme l'API. Un traitant d'un
 * autre client relève de l'interrupteur « client ».
 */
export function canCreateTicket(src: (Partial<FeatureState> & { is_dt_agent?: boolean }) | null | undefined): boolean {
  if (!src) return false;
  return featureEnabled(src, src.is_dt_agent === true ? 'ticket_create_staff' : 'ticket_create_client');
}
